import { BaseStructuredData } from './types';
import { createJsonLdScript } from './utils';

export interface StructuredDataProps {
  data: BaseStructuredData | BaseStructuredData[];
  id?: string;
}

/**
 * Pure server-side rendered structured data component
 * Renders a simple script tag with JSON-LD content during SSR
 */
export const StructuredData = ({ data, id }: StructuredDataProps) => {
  if (!data) return null;

  const scriptId = id || `structured-data-${crypto.randomUUID()}`;

  try {
    const jsonLdContent = createJsonLdScript(data);

    return (
      <script
        id={scriptId}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdContent }}
      />
    );
  } catch (error) {
    console.error('Error creating structured data script:', error);
    return null;
  }
};

/**
 * Alias for consistency with previous API
 */
export const StructuredDataSSR = StructuredData;
